import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app';
import { appConfig } from './app/app.config';
import { environment } from '@env';



bootstrapApplication(AppComponent, appConfig);
